var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.66699 17.9126C5.66699 18.3215 5.41809 18.6892 5.03849 18.8411L1.3715 20.3084C0.714622 20.5712 0 20.0874 0 19.3799V2.86732C0 2.45835 0.249029 2.0906 0.628775 1.93878L4.29577 0.472738C4.95261 0.210138 5.66699 0.693893 5.66699 1.40128V17.9126Z",
    fill: "#3B81B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5764 1.75084C16.0216 1.8621 16.334 2.2621 16.334 2.721V19.3263C16.334 19.9769 15.7226 20.4543 15.0914 20.2965L8.42443 18.6295C7.97928 18.5182 7.66699 18.1183 7.66699 17.6594V1.05481C7.66699 0.404275 8.27832 -0.0730777 8.90945 0.0846508L15.5764 1.75084Z",
    fill: "#3B81B4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 17.513C24 17.922 23.751 18.2897 23.3713 18.4416L19.7053 19.9075C19.0484 20.1701 18.334 19.6864 18.334 18.9789V2.46689C18.334 2.05794 18.583 1.6902 18.9627 1.53837L22.6287 0.072465C23.2856 -0.190184 24 0.293571 24 1.00099V17.513Z",
    fill: "#3B81B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.cc4e1fae5e2d24b21bc0c8d78b223efa.svg";
export { ForwardRef as ReactComponent };